export default function CReference() {
  return <h2>C Reference</h2>;
}
